<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ data.display_name }}</p>
      <b-field class="top-select is-pulled-right" label="Inactive">
        <b-switch type="is-danger" v-model="data.inactive" />
      </b-field>
      <b-field class="top-select is-pulled-right" label="Responsible">
        <b-select v-model="data.responsible">
          <option v-for="option in adminUsers" :key="option.id">
            {{ option.name }}
          </option>
          <option>None</option>
        </b-select>
      </b-field>
      <b-field class="top-select is-pulled-right" label="Priority">
        <b-select v-model="data.priority">
          <option v-for="option in priorityOptions" :key="option.value">
            {{ option.value }}
          </option>
        </b-select>
      </b-field>
      <b-field class="top-select is-pulled-right" label="Status">
        <b-select v-model="data.status">
          <option v-for="option in statusOptions" :key="option.value">
            {{ option.value }}
          </option>
        </b-select>
      </b-field>
      <b-field class="top-select is-pulled-right" label="Last Updated">
        <p>{{ data.last_updated }}</p>
      </b-field>
    </header>
    <section class="modal-card-body section">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="section">
              <h2 class="title pd-font uppercase spacing">Organization</h2>
              <b-field label="Organization Number">
                <b-input v-model="data.organization_number"></b-input>
              </b-field>
              <b-field label="Domain">
                <b-input v-model="data.domain"></b-input>
              </b-field>
              <b-field label="Company ID">
                <b-input disabled v-model="data.company_key"></b-input>
              </b-field>
              <b-field label="Industry">
                <b-input disabled v-model="data.industry"></b-input>
              </b-field>
            </div>
            <div class="section">
              <div @click="toggleAddressCollapse()">
                <h2 class="title pd-font uppercase spacing">
                  Address
                  <b-icon
                    :icon="!addressCollapsed ? 'menu-down' : 'menu-up'"
                  ></b-icon>
                </h2>
              </div>
              <b-collapse position="is-bottom" :open="addressCollapsed">
                <b-field>
                  <b-input
                    expanded
                    placeholder="Street"
                    v-model="address.street"
                  ></b-input>
                  <b-input
                    placeholder="Number"
                    v-model="address.number"
                  ></b-input>
                </b-field>
                <b-field>
                  <b-input
                    placeholder="City"
                    expanded
                    v-model="address.city"
                  ></b-input>
                  <b-input
                    placeholder="Postal Code"
                    v-model="address.postal_code"
                  ></b-input>
                </b-field>
                <b-field>
                  <b-input
                    placeholder="Region"
                    v-model="address.region"
                  ></b-input>
                </b-field>
                <b-field>
                  <b-input
                    placeholder="Country"
                    v-model="address.country"
                  ></b-input>
                </b-field>
              </b-collapse>
            </div>
          </div>
          <div class="column">
            <div class="section">
              <h2 class="title pd-font uppercase spacing">
                Contacts
                <a @click="createContact"
                  ><i class="material-icons has-text-success">add_circle</i></a
                >
              </h2>
              <div v-if="Object.keys(contacts).length > 0">
                <article
                  class="media"
                  :key="user.email"
                  v-for="user in contacts"
                >
                  <a @click="updateContact(user)"
                    ><i class="material-icons has-text-info">edit</i></a
                  >
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong
                          >{{ user.first_name }} {{ user.last_name }}</strong
                        ><a
                          v-if="user.linkedin"
                          :href="user.linkedin"
                          target="_blank"
                        >
                          <i class="fab fa-linkedin icon"></i
                        ></a>
                        <br />
                        <span v-if="user.role"
                          ><small class="is-italic">{{ user.role }}</small> <br
                        /></span>
                        <small>{{ user.email }}</small>

                        <span class="is-pulled-right"
                          ><small>{{ user.phone }}</small></span
                        >
                        <br />
                      </p>
                    </div>
                  </div>
                </article>
              </div>
              <div v-else>
                <b-message type="is-info"> No contacts added yet. </b-message>
              </div>
            </div>
            <div class="section">
              <h2 class="title pd-font uppercase spacing">Events</h2>
              <EventColumn
                :company_key="data.company_key"
                :closeModal="closeModal"
                :isAdmin="true"
              />
            </div>
          </div>
          <div class="column">
            <div class="section">
              <h2 class="title pd-font uppercase spacing">Notes</h2>

              <div class="notes-log">
                <article class="note" :key="i" v-for="(note, i) in notes_log">
                  <div>{{ note.note }}</div>
                  <small>{{ getMoment(note.date) }}</small>
                </article>
                <article
                  class="note"
                  v-if="data.notes && data.notes.trim() !== ''"
                >
                  <div>{{ data.notes }}</div>
                </article>
              </div>
              <b-field>
                <b-input
                  expanded
                  textarea
                  placeholder="Notes"
                  type="textarea"
                  rows="6"
                  v-model="note"
                ></b-input>
              </b-field>
              <button
                class="button is-success"
                type="button"
                @click="addNote(note)"
              >
                Add note
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-warning" type="button" @click="closeModal">
        Close <i class="material-icons">clear</i>
      </button>
      <button class="button is-success" type="button" @click="handleSave">
        Save <i class="material-icons">save</i>
      </button>
      <div class="delete-button-container">
        <button
          class="button is-danger"
          type="button"
          @click="deleteCompany"
          :disabled="!data.inactive"
        >
          Delete <i class="material-icons">delete_forever</i>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import EventColumn from "@/components/app/main/EventColumn";
import CompanyContact from "@/components/app/company/CompanyContact";
import options from "./options";
import _ from "lodash";
import * as firebase from "firebase/app";
import moment from "moment";

export default {
  components: {
    EventColumn,
  },
  data: () => {
    return {
      priorityOptions: {
        ...options.priorityOptions,
      },
      statusOptions: {
        ...options.statusOptions,
      },
      addressCollapsed: false,
    };
  },
  computed: {
    ...mapState({
      data: function (state) {
        const { companies } = state.admin.companies;
        const company = companies[this.company_key];
        return company;
      },
      address: function (state) {
        const { companies } = state.admin.companies;
        const company = companies[this.company_key];
        return { ...company.address };
      },
      contacts: function (state) {
        const { companies } = state.admin.companies;
        if (companies[this.company_key].contacts === undefined) {
          return {};
        } else {
          return companies[this.company_key].contacts;
        }
      },
      users: function (state) {
        const { users } = state.admin;
        const companyUsers = Object.keys(users).map((d) => {
          if (users[d].company_key === this.data.company_key) {
            return users[d];
          }
        });
        return companyUsers;
      },
      notes_log: function (state) {
        const { companies } = state.admin.companies;
        const company = companies[this.company_key];
        return _.orderBy({ ...company.notes_log }, "date", "desc");
      },
    }),
    ...mapGetters({
      adminUsers: "admin/getAdminUsers",
    }),
  },
  methods: {
    handleSave({ close } = { close: true }) {
      const { dispatch } = this.$store;
      const { address, contacts } = this;
      const payload = {
        ...this.data,
        address,
        contacts,
        last_updated: new Date().toISOString().slice(0, 10),
      };
      dispatch("admin/companies/saveCompanyDetails", payload);
      if (close) this.$parent.close();
    },
    updateContact(data) {
      this.$modal.open({
        parent: this,
        component: CompanyContact,
        props: {
          ...data,
          deletable: true,
          callback: this.saveContact,
          onDelete: this.deleteContact,
        },
        hasModalCard: true,
      });
    },
    deleteContact(key) {
      delete this.contacts[key];
      this.handleSave({ close: false });
    },
    deleteCompany() {
      const { dispatch } = this.$store;
      const payload = this.data.company_key;
      dispatch("admin/companies/deleteComapny", payload);
      this.$parent.close();
    },
    closeModal() {
      this.$parent.close();
    },
    createContact() {
      this.$modal.open({
        parent: this,
        component: CompanyContact,
        props: { callback: this.addContact },
        hasModalCard: true,
      });
    },
    addContact(data) {
      if (this.data.contacts === undefined) {
        this.data.contacts = {};
      }
      this.contacts[data.email] = data;
      this.handleSave({ close: false });
    },
    saveContact(data) {
      if (this.data.contacts === undefined) {
        this.data.contacts = {};
      }
      this.contacts[data.email] = data;
      this.handleSave({ close: false });
    },
    toggleAddressCollapse() {
      this.addressCollapsed = !this.addressCollapsed;
    },
    addNote(note) {
      if (note.trim() === "") return;
      if (!this.data.notes_log) {
        this.data.notes_log = [];
      }
      this.data.notes_log.push({
        date: firebase.firestore.Timestamp.fromDate(new Date()),
        note,
      });
      this.handleSave({ close: false });
    },
    getMoment(timestamp) {
      return moment(timestamp.toDate()).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.company_key = this.$attrs.company_key;

    const closeModalOnBackButton = this.$router.beforeEach((to, from, next) => {
      if (from.path == "/app/admin/companies") {
        next(false);
        this.$parent.close();
      } else {
        next(true);
      }
    });

    this.$once("hook:destroyed", () => {
      closeModalOnBackButton();
    });
  },
};
</script>

<style scoped>
.top-select {
  padding: 0 1em;
}
.modal-card {
  max-width: none !important;
  width: 100vw !important;
  margin: 0 !important;
  height: 100vh !important;
  border-radius: 0 !important;
}
.material-icons {
  transform: scale(0.7);
  margin-left: 5px;
}
.tag {
  margin-right: 5px;
}
.delete-button-container {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.notes-log {
  overflow-y: auto;
  max-height: 20em;
  margin-bottom: 2em;
}
.notes-log .note {
  display: flex;
  margin-top: 1em;
  border-bottom: 1px solid #dbdbdb;
  white-space: pre-line;
}
.notes-log .note > small {
  color: gray;
}
.notes-log .note > div {
  flex: 1;
  padding: 0.2em;
}
</style>
